import React from "react";
import AppHeader from "./../../../components/header/index";
import ContractEndDateComponent from "./ContractEnd";
import FollowUpComponent from "./FollowUp";
import { Stack } from "@mui/material";
import MeetingCalenderComponent from "./MeetingCalender";

const AgentCalenderPage = () => {
  return (
    <AppHeader>
      <Stack gap={4}>
        <FollowUpComponent />
        <ContractEndDateComponent />
        <MeetingCalenderComponent />
      </Stack>
    </AppHeader>
  );
};

export default AgentCalenderPage;
